<script setup lang="ts">
import { AlertDialogAction, type AlertDialogActionProps } from 'radix-vue';
import { computed, type HTMLAttributes } from 'vue';

import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const props = defineProps<
    AlertDialogActionProps & { class?: HTMLAttributes['class'] }
>();

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
});
</script>

<template>
    <AlertDialogAction
        v-bind="delegatedProps"
        :class="cn(buttonVariants(), props.class)"
    >
        <slot />
    </AlertDialogAction>
</template>
